import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { NetworkService } from './core/services/network.service';
import { ToastsContainerComponent } from './shared/components/toasts-container/toasts-container.component';

@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, ToastsContainerComponent, TranslateModule],
  template: `
    @if (!networkService.isOnline()) {
      <div
        class="network-offline-banner bg-warning text-dark text-center py-2 px-3 fw-semibold position-fixed top-0 start-0 w-100"
        style="z-index: 9999;"
      >
        ⚠️ {{ 'NETWORK.OFFLINE_BANNER' | translate }}
      </div>
    }
    <router-outlet></router-outlet>
    <app-toasts-container></app-toasts-container>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100vh;
      }
      .network-offline-banner {
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
        font-size: 14px;
      }
    `,
  ],
})
export class App {
  private readonly router = inject(Router);
  private readonly modalService = inject(NgbModal);
  readonly networkService = inject(NetworkService);

  constructor() {
    // Đóng tất cả modal khi có thay đổi route
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.modalService.dismissAll();
      });
  }
}
